/* eslint-disable no-unused-vars */
import { Scene, Input, Math as MathPhaser, Curves } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, randomDirection, setLastMovement, getLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";
import HealthBar from "../../phaser/components/healthBar";

let cursors;
let walls;

let characterSelected;
let objNames = {};
let enemy;
// let timeoutDoor = {};
let footsteps;
// let speedEnemy = 50;
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;

let randomPointsEnemy = [
    { x: 2792, y: 650 },
    { x: 1623, y: 1205 },
    { x: 450, y: 1460 },
    { x: 2784, y: 1470 },
    { x: 511, y: 383 },
    { x: 1376, y: 603 },
];
let startKill = false;
let instructionsHandler = 0;

let allMembers;
let allMembersFollows;
let lastCoordenates = null;

export default class Game7 extends Scene {

    constructor() {
        super({ key: "Game7" });
    }
    init(data) {
        randomPointsEnemy = [
            { x: 2792, y: 650 },
            { x: 1623, y: 1205 },
            { x: 450, y: 1460 },
            { x: 2784, y: 1470 },
            { x: 511, y: 383 },
            { x: 1376, y: 603 },
        ];
        this.hp = {}

        // this.scene.restart();
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;

        hasLightstick = false;
        // speedEnemy = 100;
        objNames = {};
        enemy = null;
        startKill = false;
        this.startAll = false;
        this.personToKill = null;
        instructionsHandler = 0;
        allMembers = ['jiu', 'sua', 'siyeon', 'handong', 'dami', 'gahyeon'];
        allMembersFollows = [{ person: 'jiu', isAlive: true }, { person: 'sua', isAlive: true }, { person: 'siyeon', isAlive: true },
        { person: 'handong', isAlive: true }, { person: 'dami', isAlive: true }, { person: 'gahyeon', isAlive: true }];
        if (characterSelected === 'yoohyeon') {
            const indexJiu = allMembers.findIndex(f => f === 'jiu');
            const indexJiuFollow = allMembersFollows.findIndex(f => f.person === 'jiu');
            allMembers.splice(indexJiu, 1);
            randomPointsEnemy.splice(indexJiu, 1);
            allMembersFollows.splice(indexJiuFollow, 1);
        } else {
            const indexCharacterSelected = allMembers.findIndex(a => a === characterSelected);
            const indexCharacterFollowsSelected = allMembersFollows.findIndex(a => a.person === characterSelected);
            randomPointsEnemy.splice(indexCharacterSelected, 1);

            allMembers.splice(indexCharacterSelected, 1);
            allMembersFollows.splice(indexCharacterFollowsSelected, 1);
        }
        this.events.off('buttonNext-dialogModal');
        setLastMovement('down');

    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    createPath() {
        return new Curves.Path(1627, 400)
            .lineTo(1627, 609)
            .lineTo(2657, 609)
            .lineTo(2657, 647)
            .lineTo(2787, 647)
            .lineTo(2787, 837)
            .lineTo(2466, 837) //
            .lineTo(2466, 666) //
            .lineTo(1627, 666) //
            .lineTo(1627, 1465) //
            .lineTo(448, 1465) //
            .lineTo(448, 1270) //
            .lineTo(687, 1270) //
            .lineTo(687, 1376) //
            .lineTo(2456, 1376) //
            .lineTo(2456, 1466) //
            .lineTo(2778, 1466) // --
            .lineTo(2778, 1342) // --
            .lineTo(2663, 1342) // --
            .lineTo(2663, 1246) // --
            .lineTo(2479, 1246) // --
            .lineTo(2479, 1371) // --
            .lineTo(655, 1371) // --
            .lineTo(655, 1296) // --
            .lineTo(380, 1296) // --
            .lineTo(380, 400) // --
            .lineTo(510, 400) // --
            .lineTo(510, 545) // --
            .lineTo(1345, 545) // RIGHT
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            switch (data.id) {
                case 'random-character-start':


                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.setText("“Oh now, holding this pain. Like the day I abandoned everything”".toUpperCase(), `note-test`, false, false);
                            break;
                        case 2:
                            this.dialogModal.setText("This phrase sounds familiar, but I can't remember where I heard it.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 3:
                            this.dialogModal.setText("Ah, the note says something else! \nBut it seems like someone has erased this part.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 4:
                            this.dialogModal.setText("I think it says... \n“DON'T TRUST YOO...“".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 5:
                            this.dialogModal.setText("I'll continue investigating to find out more.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 6:
                            this.dialogModal.close();
                            this.startAll = true;
                            this.modalStart = null;
                            instructionsHandler = 0;
                            this.showingInstruction = false;

                            if(this.isMobile) {
                                this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game7`, 300);
                                this.joystickManager.createJoystick();
                                this.joystickManager.activate(hasLightstick);
        
                            }
                            break;
                    }
                    break;
                case 'yoohyeon-character-start':

                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.setText("“It's time to stop holding this pain. \nYou will find the answers you seek by facing the six nightmares.“".toUpperCase(), `note-test`, false, false);
                            break;
                        case 2:
                            this.dialogModal.setText("Could these “nightmares“ refer to people? \nI need to investigate this place further.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 3:
                            this.dialogModal.close();
                            this.startAll = true;
                            this.modalStart = null;
                            instructionsHandler = 0;
                            this.showingInstruction = false;

                            if(this.isMobile) {
                                this.joystickManager = new Joystick(objNames[characterSelected], `enemy-game7`, 300);
                                this.joystickManager.createJoystick();
                                this.joystickManager.activate(hasLightstick);
                            }
                            break;
                    }
                    break;
                case 'yoohyeon-start-kill':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.setText("What are you doing here?".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 2:
                            this.dialogModal.setText(" . . .", `yoohyeon-hallway`, false, false);
                            break;
                        case 3:
                            this.dialogModal.setText("Aren't you going to say anything?".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 4:
                            this.dialogModal.setText(" . . .", `yoohyeon-hallway`, false, false);
                            break;
                        case 5:
                            this.dialogModal.setText("I think I should leave this place.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 6:
                            this.dialogModal.close();
                            objNames[characterSelected].active = false;
                            objNames[characterSelected].setVelocity(0);
                            this.cameras.main.startFollow(enemy, true);
                            startKill = true;
                            // objNames[characterSelected].active = true;
                            instructionsHandler = 0
                            this.countStartKill = 0;
                            this.showingInstruction = false;

                            // if(this.isMobile) {
                            //     this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game7`, 300);
                            // }
                            enemy.startFollow({
                                duration: 70000,
                                yoyo: false,
                                repeat: 0,
                                //                             rotateToPath: true,
                                //   rotationOffset: 90,
                                // startAt: 1,
                                onUpdate: function (test) {
                                    // Scale the delta vector to a 1-second velocity vector.
                                    enemy.body.velocity
                                        .copy(enemy.pathDelta)
                                        .scale(1000 / this.parent.systems.game.loop.delta);

                                },
                                onComplete: () => {
                                    
                                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                        this.cameras.main.startFollow(objNames[characterSelected], true);
                                        if (progress === 1) {
                                            objNames[characterSelected].setImmovable();
                                            objNames[characterSelected].setPosition(1627, 600);
                                            //TODO FOCUS CHARACTER PPAL
                                            objNames[characterSelected].anims.play(`up-${characterSelected}-game7`, true)
                                            this.cameras.main.fadeIn();
                                            // this.dialogModal._createWindow(this, 'alert-finish-kill', null, true);
                                            this.dialogModal._createImageDialog(this, 'alert-finish-kill');

                                            this.dialogModal.setText("I COULD NOT ESCAPE MY DEJA VU . . . ", `${characterSelected}-hallway`,false, true);

                                            enemy.destroy();
                                            enemy = this.physics.add.sprite(1627, 400, `enemy-game7`, 4).setScale(2.5);
                                            reposeAnimation(this, `enemy-game7`);

                                            this.physics.add.collider(enemy, objNames[characterSelected], () => {
                                                this.countStartKill++;
                                                enemy.anims.play(`repose-enemy-game7`, true);

                                                
                                                if (this.countStartKill === 10) {
                                                    if (this.personToKill && this.personToKill.person === characterSelected) {
                                                        // countenemyFinal++;
                                                        this.deadSprite.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
                                                        this.deadSprite.visible = true;
                                                        this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                                                        objNames[characterSelected].active = false;
                                                        objNames[characterSelected].setVelocity(0)
                                                        objNames[characterSelected].setTint(0x473334);
                                                        // if (countenemyFinal > 100) {
                                                        setTimeout(() => {
                                                            this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                                                if (progress === 1) {
                                                                    clearInterval(this.countdown);
                                                                    footsteps.stop();
                                                                    this.ppalSong.stop();
                                                                    this.scene.stop();
                                                                    localStorage.setItem('td', 1);
                                                                    this.events.off('buttonNext-dialogModal');
                                                                    this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 7, lastCoordenates });
                                                                    // this.scene.restart();
                                                                }
                                                            });

                                                        }, 1000);
                                                        // }

                                                    }
                                                }
                                            }, null, this);

                                            // objNames[characterSelected].active = true;



                                        }
                                    });
                                },
                            });
                            //AQUI MOSTRAR A LAS DEMAS

                            break;
                    }
                    break;
                case 'alert-yoohyeon-kill':
                    this.countStartKill = 0;
                    this.dialogModal.close();
                    this.showingInstruction = false;
                    this.modalEscapeShow = false;

                    break;
                case 'alert-finish-kill':
                    this.countStartKill = 0;
                    this.physics.moveToObject(enemy, objNames[characterSelected], 100);
                    // this.dialogModal.close();
                    break;
                case 'yoohyeon-kill-character':
                    objNames[data.data.character].destroy();
                    this.deadSprite.visible = false;
                    // enemy.active = true;
                    enemy.resumeFollow();
                    // this.cameras.main.startFollow(objNames[characterSelected], true);
                    // objNames[characterSelected].active = true;
                    // enemy.setPosition(1627, 400);
                    this.countOverKill = 0;
                    this.dialogModal.close();
                    this.isKilling = false;
                    this.showingInstruction = false;

                    break;
                case 'finish-lightstick':
                    this.dialogModal.close();
                    
                    setTimeout(() => {
                        let total = JSON.parse(localStorage.getItem('noL'));
                        if (total) {
                            if (!total.includes(7)) {
                                total.push(7);
                                localStorage.setItem('noL', JSON.stringify(total));

                            }
                        } else {
                            localStorage.setItem('noL', JSON.stringify([7]));
                        }

                        
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                footsteps.stop();
                                this.ppalSong.stop();
                                this.scene.stop();
                                this.events.off('buttonNext-dialogModal');
                                if(this.joystickManager) {
                                    this.joystickManager.destroyTest();
                                }
                                
                                this.scene.start(`Win`, { characterSelected: characterSelected, level: 7, lastCoordenates });
                            }
                        });
                    }, 2000);
                    break;
            }
        });

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager && !startKill) {
                        this.joystickManager.show();
                        this.buttonAction.active = true;
                        this.buttonAction.visible = true;
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 3252);
        this.physics.world.setBounds(0, 0, 3252);

        this.ppalSong = this.sound.add(`dejavuSong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        this.path = this.createPath();
        this.graphics = this.add.graphics();
        this.graphics.lineStyle(3, 0xffffff, 1);
        this.path.draw(this.graphics, 128);
        this.map = mapHandler(this, 'game7', false, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);

        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });

        this.object.setScale(3);
// 
        this.instructionMessage = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        
        // this.instructionMessage = this.add.text(0, 200, 'INTERACT: SPACEBAR', { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setVisible(false);
        // this.instructionMessage.setPosition(this.screenCenterX + 100, this.screenCenterY + 100);
        // this.instructionMessage.setVisible(true);

        if (characterSelected === 'yoohyeon') {
            objNames[characterSelected] = this.physics.add.sprite(1622, 2051, `enemy-game7`, 4).setDepth(1);
            walkAnimation(this, `enemy-game7`);
            reposeAnimation(this, `enemy-game7`);
            turnStaticAnimation(this, `enemy-game7`);
            upStaticAnimation(this, `enemy-game7`);
            leftStaticAnimation(this, `enemy-game7`);
            rightStaticAnimation(this, `enemy-game7`);
            backStaticAnimation(this, `enemy-game7`);
            lightstickAnimation(this, `enemy-game7`);
            lightstickAnimation(this, `yoohyeon-game7`);
    
        } else {

            objNames[characterSelected] = this.physics.add.sprite(1622, 2051, `${characterSelected}-game7`, 4).setDepth(1);
            walkAnimation(this, `${characterSelected}-game7`);
            reposeAnimation(this, `${characterSelected}-game7`);
            turnStaticAnimation(this, `${characterSelected}-game7`);
            upStaticAnimation(this, `${characterSelected}-game7`);
            leftStaticAnimation(this, `${characterSelected}-game7`);
            rightStaticAnimation(this, `${characterSelected}-game7`);
            backStaticAnimation(this, `${characterSelected}-game7`);
            lightstickAnimation(this, `${characterSelected}-game7`);

            objNames[characterSelected].anims.play(`repose-${characterSelected}-game7`, true)

        }

        objNames[characterSelected].setScale(2.5);

        this.physics.add.collider(objNames[characterSelected], walls);


        this.physics.add.collider(objNames[characterSelected], this.object);

        if (characterSelected !== 'yoohyeon') {

            enemy = this.add.follower(this.path, 1627, 400, `enemy-game7`).setScale(2.5);
            this.physics.add.existing(enemy);
            enemy.body.setImmovable(true);


            walkAnimation(this, `enemy-game7`);
            reposeAnimation(this, `enemy-game7`);
            turnStaticAnimation(this, `enemy-game7`);
            upStaticAnimation(this, `enemy-game7`);
            leftStaticAnimation(this, `enemy-game7`);
            rightStaticAnimation(this, `enemy-game7`);
            backStaticAnimation(this, `enemy-game7`);
            lightstickAnimation(this, `enemy-game7`);

            enemy.anims.play(`repose-enemy-game7`, true)

            this.physics.add.collider(enemy, walls);
            for (const [i, m] of allMembers.entries()) {

                objNames[m] = this.physics.add.sprite(randomPointsEnemy[i].x, randomPointsEnemy[i].y, `${m}-game7`);
                objNames[m].setImmovable();
                objNames[m].setScale(2.5);


                walkAnimation(this, `${m}-game7`);
                reposeAnimation(this, `${m}-game7`);
                turnStaticAnimation(this, `${m}-game7`);
                upStaticAnimation(this, `${m}-game7`);
                leftStaticAnimation(this, `${m}-game7`);
                rightStaticAnimation(this, `${m}-game7`);
                backStaticAnimation(this, `${m}-game7`);
                lightstickAnimation(this, `${m}-game7`);

                objNames[m].anims.play(`repose-${m}-game7`, true);

                this.physics.add.collider(objNames[m], walls, () => {
                    randomDirection(`${m}-game7`);
                }, null, this);
                this.physics.add.collider(objNames[m], this.object, () => {
                    randomDirection(`${m}-game7`);
                }, null, this);

                this.physics.add.collider(objNames[characterSelected], objNames[m], () => {
                    if (startKill) {
                        this.countStartKill++;

                        
                        if (this.countStartKill === 10) {
                            if(!this.isKilling) {
                                this.showingInstruction = true;
                                this.modalEscapeShow = true;
                                // this.dialogModal._createWindow(this, 'alert-yoohyeon-kill', null, true);
                                this.dialogModal._createImageDialog(this, 'alert-yoohyeon-kill');

                                this.dialogModal.setText("Escape! \nYou don't have a chance to defeat her.".toUpperCase(), `${m}-hallway`, false, true);
                            } else {
                                this.dialogModal.close();
                            }
                        }
                    }

                }, null, this);

                let countenemy = 0;

                this.countOverKill = 0;

                this.physics.add.overlap(enemy, objNames[m], function onOverlap() {
                    this.countOverKill++;
                    if (startKill) {
                        if (this.personToKill.person === m) {
                            countenemy++;
                            if (countenemy === 10) {
                                this.isKilling = true;
                                // objNames[characterSelected].active = false;
                                // objNames[characterSelected].setVelocity(0);
                                // this.cameras.main.startFollow(enemy, true);

                                this.deadSprite.setPosition(objNames[m].x, objNames[m].y);
                                this.deadSprite.visible = true;
                                this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                                objNames[m].setVelocity(0)
                                objNames[m].active = false;
                                objNames[m].setFrame(4);
                                enemy.pauseFollow();
                                enemy.anims.play(`repose-enemy-game7`, true)
                                allMembersFollows.map(a => {
                                    if (a.person === m) {
                                        a.isAlive = false;
                                        this.showingInstruction = true;

                                        // this.dialogModal._createWindow(this, 'yoohyeon-kill-character', null, true, { character: m });
                                        if(this.modalEscapeShow) {
                                            this.dialogModal.close();
                                        }
                                        // this.dialogModal._createImageDialog(this, 'yoohyeon-kill-character',  { character: m });

                                        // this.dialogModal.setText(`Yoohyeon attacked ${m}! \nI'm in my deja vu. \nI need to escape!`.toUpperCase(), `${characterSelected}-hallway`, false, true);

                                        setTimeout(() => {
                                            objNames[m].destroy();
                                            this.deadSprite.visible = false;
                                            // enemy.active = true;
                                            enemy.resumeFollow();
                                            // this.cameras.main.startFollow(objNames[characterSelected], true);
                                            // objNames[characterSelected].active = true;
                                            // enemy.setPosition(1627, 400);
                                            this.countOverKill = 0;
                                            this.dialogModal.close();
                                            this.isKilling = false;
                                            this.showingInstruction = false;

                                            // if(this.isMobile && !this.joystickManager) {
                                            //     this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game7`, 300);
                                            // }
                                        }, 500);


                                    }

                                    return a;
                                });
                            }
                        }
                    }

                }.bind(this),
                    function process(sprite, tile) {
                        return tile.collides;
                    }
                );

            }



            this.countStartKill = 0;

            this.physics.add.overlap(objNames[characterSelected], enemy, function onOverlap() {

            // this.physics.add.collider(objNames[characterSelected], enemy, () => {
                if (!startKill) {

                    if (!this.noShowInstructions) {
                        this.instructionMessage.setPosition(this.screenCenterX + 60, this.screenCenterY + 30);
                        this.instructionMessage.setVisible(true);
                    }

                    if (this.spaceBar.isDown || (this.isMobile && this.buttonAction.isDown)) {
                        this.instructionMessage.setVisible(false);
                        clearTimeout(this.timeoutStartKill);
                        this.timeoutStartKill = setTimeout(() => {
                            this.noShowInstructions = true;
                            this.instructionMessage.setVisible(false);
                            objNames[characterSelected].active = false;
                            if(this.isMobile) {
                                this.joystickManager.pause();
                                this.buttonAction.active = false;
                                this.buttonAction.visible = false;
                                
                            }
                            this.showingInstruction = true;
                            // this.dialogModal._createWindow(this, 'yoohyeon-start-kill', null, true);
                            this.dialogModal._createImageDialog(this, 'yoohyeon-start-kill');
    
                            this.dialogModal.setText(". . .".toUpperCase(), `yoohyeon-hallway`, false, false);
                        }, 1000);
                    }

                    setTimeout(() => {
                        this.instructionMessage.setVisible(false);
                    }, 1000);
                }
            }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

           
        } else {

            this.victim = this.physics.add.sprite(2797, 570, `jiu2-game7`, 4);

            this.victim.setScale(2.5);
            this.victim.setImmovable();
            this.victim.visible = false;

            
            // } while(randomPointsEnemy[aux] !== itemRandom);
            for (const m of allMembers) {
                
                let itemRandom =  null;
                let aux =  Math.floor(Math.random() * randomPointsEnemy.length);
                itemRandom = randomPointsEnemy[aux];
                randomPointsEnemy.splice(aux, 1);
                // let isSame = false;

                // let itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];
                // while (itemRandom === itemRandom2) {
                //     isSame = true;
                //     itemRandom = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];
                // }

                // if (!isSame) {
                //     itemRandom = itemRandom2;
                // }

                objNames[m] = this.physics.add.sprite(itemRandom.x, itemRandom.y, `${m}-game7`);
                objNames[m].setImmovable();
                objNames[m].setScale(2.5);

                walkAnimation(this, `${m}-game7`);
                reposeAnimation(this, `${m}-game7`);
                turnStaticAnimation(this, `${m}-game7`);
                upStaticAnimation(this, `${m}-game7`);
                leftStaticAnimation(this, `${m}-game7`);
                rightStaticAnimation(this, `${m}-game7`);
                backStaticAnimation(this, `${m}-game7`);
                lightstickAnimation(this, `${m}-game7`);

                // this.hp[m] = new HealthBar(this, objNames[m].x - 40, objNames[m].y - 70);
                // this.hp[m].setVisible(true);

                objNames[m].anims.play(`repose-${m}-game7`, true);

                this.physics.add.collider(objNames[m], walls, () => {
                    randomDirection(`${m}-game7`);
                }, null, this);
                this.physics.add.collider(objNames[m], this.object, () => {
                    randomDirection(`${m}-game7`);
                }, null, this);

                // let countenemy = 0;

                this.countOverKill = 0;

                this.physics.add.collider(objNames[characterSelected], objNames[m], () => {


                    this.ignoreCursor = true;
                    objNames[characterSelected].anims.play(`${getLastMovement()}-enemy-game7`, true);

 
                    this.deadSprite.setPosition(objNames[m].x, objNames[m].y);
                    this.deadSprite.visible = true;
                    this.deadSprite.anims.play(`deadSpriteAnimation`, true);

                    objNames[m].setVelocity(0, 0);
                    objNames[m].setFrame(4);
                    objNames[m].active = false;
                    // objNames[characterSelected].active = false;
                    setTimeout(() => {
                        allMembersFollows.map(d => {
                            if (d.person === m) {
                                d.isAlive = false;
                            }
                            return d;
                        });
                        // const membersDead = allMembersFollows.filter(a => !a.isAlive);
                        objNames[m].destroy();
                        this.deadSprite.visible = false;
                        objNames[characterSelected].setVelocity(0, 0);
                        objNames[characterSelected].active = true;
                        this.countOverKill++;
                        // this.countOverKill = membersDead.length;
                        this.ignoreCursor = false;

                    }, 500);

                }, null, this);

                // this.physics.add.collider(objNames[characterSelected], objNames[m], () => {
                //     if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                //         this.deadSprite.setPosition(objNames[m].x, objNames[m].y);
                //         this.deadSprite.visible = true;
                //         this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                //         if (this.hp[m] && this.hp[m].decrease(1)) {
                //             this.countOverKill++;
                //             objNames[m].active = false;
                //             objNames[m].visible = false;
                //             allMembersFollows.map(a => {
                //                 if (a.person === m) {
                //                     a.isAlive = false;
                //                 }

                //                 return a;
                //             });
                //             this.hp[m].setVisible(false);
                //             objNames[m].destroy();
                //             this.deadSprite.visible = false;

                //         }
                //     }

                //     setTimeout(() => {
                //         this.deadSprite.visible = false;
                //     }, 1000);

                // }, null, this);

            }

            this.physics.add.overlap(objNames[characterSelected], this.victim, function onOverlap() {
                this.instructionMessage.setPosition(this.screenCenterX + 60, this.screenCenterY + 30);
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    clearTimeout(this.timeoutDialog);
                    this.timeoutDialog = setTimeout(() => {
                        if (this.victim.visible) {
                            this.deadSprite.setPosition(this.victim.x, this.victim.y);
                            this.deadSprite.visible = true;
                            this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                            this.victim.visible = false;
                           
                            this.showingInstruction = true;
                            hasLightstick = true;
                            if(this.isMobile) {
                                this.joystickManager.setLightStickValue(hasLightstick);
                            }
                            this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                this.deadSprite.visible = false;
                                this.instructionMessage.setVisible(false);

                                this.startAll = false;
                                // objNames[characterSelected] = this.physics.add.sprite(1622, 2051, `yoohyeon-game7`);
                                
                                // lightstickAnimation(this, `lightstick-yoohyeon-game7`);
                                if (progress === 1) {
                                    objNames[characterSelected].setTexture('yoohyeon-game7');
                                    objNames[characterSelected].setPosition(1622, 2051);
                                    objNames[characterSelected].anims.play(`lightstick-yoohyeon-game7`, true);
                                    // objNames[characterSelected] = null;
                                    this.cameras.main.fadeIn();
                                    // this.dialogModal._createWindow(this, 'finish-lightstick', null, true)
                                    
                                    this.dialogModal._createImageDialog(this, 'finish-lightstick');
                                    this.dialogModal.setText("I found my lightstick! \nI will never forget this nightmare".toUpperCase(), `${characterSelected}-hallway`,false, false)
                                    // setTimeout(() => {
                                    //     this.dialogLightstickVisible = true;
                                    // }, 1000);
                                    

                                }
                            });
                        }
                    }, 1000);
                }

                setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);

            }.bind(this),
                function process(sprite, tile) {
                    return tile.collides;
                }
            );


        }

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.deadSprite = this.physics.add.sprite(1622, 2051, `humo-game7`).setScale(2.5).setVisible(false).setDepth(2);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game7', { start: 0, end: 17 }),
            frameRate: 8,
            repeat: -1
        });


        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);

        window.addEventListener("blur", () => {
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });

        this.modalStart = true;

        
        if (characterSelected !== 'yoohyeon') {
            objNames[characterSelected].anims.play(`repose-${characterSelected}-game7`);
            // this.dialogModal._createWindow(this, 'random-character-start', null, true)
            this.showingInstruction = true;
            this.dialogModal._createImageDialog(this, 'random-character-start');

            this.dialogModal.setText("Where am I? It feels like I've been here before, is this a deja vu? \nOh! Here's a note. \nI'll read it to see if it gives me any clues about this place.".toUpperCase(), `${characterSelected}-hallway`, false, false)
            
        } else {

            const x = 40;
            const y = 16;

            this.add.image(x, y, `logo`, 0).setScale(0.7).setOrigin(1, 0).setScrollFactor(0);
            this.textMask = this.add.bitmapText(x + 40, y + 5, 'pixelfont',`${this.countOverKill}/6`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5)

            objNames[characterSelected].anims.play(`repose-enemy-game7`);
            this.showingInstruction = true;
            // this.dialogModal._createWindow(this, 'yoohyeon-character-start', null, true)
            this.dialogModal._createImageDialog(this, 'yoohyeon-character-start');

            this.dialogModal.setText("Where am I? Is that a throne? \nOh! Here's a note.\nI'm going to read it to see if it gives me any clues about this place.".toUpperCase(), `${characterSelected}-hallway`, false, false)

        }

        setTimeout(() => {
            this.dialogPpalVisible = true;
        }, 1000);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        this.lightstickCounter = new LightstickCounter(this);
        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50;
        this.screenCenterY = this.cameras.main.worldView.y;
    }


    update() {

        const characterName = characterSelected === 'yoohyeon' ? hasLightstick ? 'yoohyeon' : 'enemy' : characterSelected;
        if (this.startAll) {

            if (objNames[characterSelected].active) {
                if (!this.isMobile) {
                    walkHandler(cursors, objNames[characterSelected], 300, `${characterName}-game7`, hasLightstick, false, this.ignoreCursor);
                } else {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }


            if (characterSelected !== 'yoohyeon') {

                if (enemy.active && startKill) {

                    if (!enemy.pause) {
                        if (enemy.x === 1627 && enemy.y >= 400 && enemy.y <= 609) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 609 && enemy.x >= 1627 && enemy.x <= 2657) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }
                        if (enemy.x === 2657 && enemy.y >= 609 && enemy.y <= 647) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 647 && enemy.x >= 2657 && enemy.x <= 2787) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }
                        if (enemy.x === 2787 && enemy.y >= 647 && enemy.y <= 837) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 837 && enemy.x <= 2787 && enemy.x >= 2466) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 2466 && enemy.y <= 837 && enemy.x >= 609) {
                            enemy.anims.play(`up-enemy-game7`, true);
                        }
                        if (enemy.y === 666 && enemy.x <= 2466 && enemy.x >= 1627) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 1627 && enemy.y <= 1465 && enemy.y >= 666) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 1465 && enemy.x <= 1627 && enemy.x >= 448) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 448 && enemy.y <= 1465 && enemy.y >= 1270) {
                            enemy.anims.play(`up-enemy-game7`, true);
                        }
                        if (enemy.y === 1270 && enemy.x <= 687 && enemy.x >= 448) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }
                        if (enemy.x === 687 && enemy.y <= 1376 && enemy.y >= 1270) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 1376 && enemy.x <= 2456 && enemy.x >= 687) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }
                        if (enemy.x === 2456 && enemy.y <= 1466 && enemy.y >= 1376) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 1466 && enemy.x <= 2778 && enemy.x >= 2456) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }
                        if (enemy.x === 2778 && enemy.y <= 1466 && enemy.y >= 1342) {
                            enemy.anims.play(`up-enemy-game7`, true);
                        }
                        if (enemy.y === 1342 && enemy.x <= 2778 && enemy.x >= 2663) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 2663 && enemy.y <= 1342 && enemy.y >= 1246) {
                            enemy.anims.play(`up-enemy-game7`, true);
                        }
                        if (enemy.y === 1246 && enemy.x <= 2663 && enemy.x >= 2479) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 2479 && enemy.y <= 1371 && enemy.y >= 1246) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 1371 && enemy.x <= 2479 && enemy.x >= 655) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 655 && enemy.y <= 1371 && enemy.y >= 1296) {
                            enemy.anims.play(`up-enemy-game7`, true);
                        }
                        if (enemy.y === 1296 && enemy.x <= 655 && enemy.x >= 380) {
                            enemy.anims.play(`left-enemy-game7`, true);
                        }
                        if (enemy.x === 380 && enemy.y <= 1296 && enemy.y >= 400) {
                            enemy.anims.play(`up-enemy-game7`, true);
                        }
                        if (enemy.y === 400 && enemy.x <= 510 && enemy.x >= 380) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }
                        if (enemy.x === 510 && enemy.y <= 545 && enemy.y >= 400) {
                            enemy.anims.play(`down-enemy-game7`, true);
                        }
                        if (enemy.y === 545 && enemy.x <= 1345 && enemy.x >= 510) {
                            enemy.anims.play(`right-enemy-game7`, true);
                        }

                    }



                    this._killPerson();

                }
            } else {

                this.textMask.setText(`${this.countOverKill}/5`);

                const findPersonAlive = allMembersFollows.findIndex(d => d.isAlive === true);

                if (findPersonAlive === -1) {
                    this.victim.active = true;
                    this.victim.visible = true;

                }

            }
        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game7`);
                    this.joystickManager.pause();
                }
            }
        }



    }

    _killPerson() {
        this.personToKill = allMembersFollows.find(m => m.isAlive);
        if (!this.personToKill) {
            this.personToKill = { person: characterSelected, isAlive: true };
        }


        this._enemyFollows(this.personToKill.person);
    }

    _enemyFollows(person) {
        this.physics.moveToObject(enemy, objNames[person], 100);
    }

}